'use client';

import {
  useContext,
  useMemo,
  useState,
  createContext,
  useCallback
} from 'react';
import { getMachineDetailsAction } from 'services/machine-details/actions';
import { EquipmentDetails } from 'services/machine-details/types';

interface SuggestedPrefixesContext {
  equipmentDetails: EquipmentDetails;
  getEquipmentDetails: (partNumber: string) => void;
}
const SuggestedPrefixesContext = createContext<SuggestedPrefixesContext>(null);
export const useSuggestedPrefixes = () => useContext(SuggestedPrefixesContext);

export const SuggestedPrefixesContextProvider = ({ children }) => {
  const [equipmentDetails, setEquipmentDetails] = useState<EquipmentDetails>();

  const getEquipmentDetails = useCallback(async (partNumber: string) => {
    try {
      // TODO - Input Validation - Ensure that all values passed to the service are allowed values:
      // partNumber should always be a string restricting generalRestrictedCharacters (@\constants\securityConstants.ts).
      const response = await getMachineDetailsAction(partNumber);
      setEquipmentDetails(response.equipmentDetails);
    } catch (error) {
      setEquipmentDetails({});
    }
  }, []);

  const contextValues = useMemo(() => {
    return {
      equipmentDetails,
      getEquipmentDetails
    };
  }, [equipmentDetails, getEquipmentDetails]);

  return (
    <SuggestedPrefixesContext.Provider value={contextValues}>
      {children}
    </SuggestedPrefixesContext.Provider>
  );
};
